import React from 'react';

function AuditorPanel({ areaActiva }) {
  return (
    <div className="ctx-card">
      <div className="ctx-card-header"><span className="ctx-card-title">Auditor IA</span></div>
      <div className="ctx-details">
        <div className="ctx-row"><span className="ctx-label">Área auditada</span><span className="ctx-value">{areaActiva || '-'}</span></div>
        <div className="ctx-row"><span className="ctx-label">Estado</span><span className="ctx-value">Alertas visibles desde Métricas / Reporte operativo</span></div>
      </div>
    </div>
  );
}

export default React.memo(AuditorPanel);
